import React, { useState } from "react";
import useScrollAnimation from "../constants/useScrollAnimation";
import "./Schools.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import "swiper/css";
import { SLIDER_AUTOPLAY_DELAY_MS } from "../constants/sliderTiming";

const cards = [
  { title: "TIGPS - Alipurduar", img: "/images/schools/alipurduar.jpg" },
  { title: "TIGPS - Bolpur", img: "/images/schools/bolpur.jpg" },
  { title: "TIGPS - Coochbehar", img: "/images/schools/coochbehar.jpg" },
  { title: "TIGPS - Durgapur", img: "/images/schools/durgapur.jpg" },
  { title: "TIGPS - Falakata", img: "/images/schools/falakata.jpg" },
  { title: "TIGPS - Gangarampur", img: "/images/schools/gangarampur.jpg" },
  { title: "TIGPS - Hooghly", img: "/images/schools/hooghly.jpg" },
  { title: "TIGPS - Jalpaiguri", img: "/images/schools/jalpaiguri.jpg" },
  { title: "TIGPS - Kolaghat", img: "/images/schools/kolaghat.jpg" },
  { title: "TIGPS - Krishnanagar", img: "/images/schools/krishnanagar.jpg" },
  { title: "TIGPS - Kanchrapara", img: "/images/schools/kanchrapara.jpg" },
  { title: "TIGPS - Midnapore", img: "/images/schools/midnapore.jpg" },
  { title: "TIGPS - Nabadwip", img: "/images/schools/nabadwip.jpg" },
  { title: "TIGPS - Raiganj", img: "/images/schools/raiganj.jpg" },
  { title: "TIGPS - Siliguri", img: "/images/schools/siliguri.jpg" },
  { title: "TIGPS - Sodepur", img: "/images/schools/sodepur.jpg" },
];

export default function TechnoSchoolsSection() {
  const [headerRef, isHeaderVisible] = useScrollAnimation(0.2);
  const [contentRef, isContentVisible] = useScrollAnimation(0.2);
  const [tiltClass, setTiltClass] = useState("");

  const triggerTilt = () => {
    setTiltClass("tilt-right");

    setTimeout(() => {
      setTiltClass("");
    }, 1400); // matches CSS animation
  };

  return (
    <section className="techno-section">
      <div className="container-custom">

        <div ref={headerRef} className={`section-header ${isHeaderVisible ? "animate-in" : ""}`}>
          <div className="section-title-body">
            <div>
              <h3 className="section-title-hm">Techno India Group of Public School</h3>
            </div>
            <div>
              {/* <button className="fac-cta">Learn more</button> */}
              {/* <a href="#" class="btn-com school-view"> Learn more</a> */}
            </div>
          </div>
          <p className="section-desc body-txt">
            Welcome to Techno India Group Public Schools, where education meets excellence. As a premier chain of schools under the Techno India Group, we are dedicated to nurturing young minds with a holistic approach to learning. Our curriculum blends academic rigor with co-curricular activities, ensuring students excel not only in examinations but also in sports, arts, and community engagement At Techno India Group Public Schools, we believe in fostering a supportive environment that encourages curiosity, creativity, and critical thinking. Our state-of-the-art facilities and qualified faculties ensure that every student receives personalized attention to....
            <a className="read-more tigps-read-more" href="#"> Read More</a>
          </p>
        </div>








        <div ref={contentRef} className="row align-items-center mt-4">
          <div className={`col-lg-4 mb-4 mb-lg-0 schools-left ${isContentVisible ? "animate-in" : ""}`}>
            <h4 className="allSchools">
              We have total <br />
              <span className="schooltext">22 Schools</span> across West Bengal
            </h4>

            {/* <a href="#!" className="btn btn-outline-dark view-btn mt-3">
              View All Schools
            </a> */}
            <a href="#" className="btn-com school-view"> View All Schools</a>
          </div>

          <div className={`col-lg-8 schools-right ${isContentVisible ? "animate-in" : ""}`}>
            <div className={`tilt-wrapper ${tiltClass}`}>
              <Swiper
                modules={[Autoplay]}
                spaceBetween={20}
                slidesPerView={3}
                loop={true}
                speed={2000}
                autoplay={{
                  delay: SLIDER_AUTOPLAY_DELAY_MS,
                  disableOnInteraction: false,
                }}
                onSlideChange={triggerTilt}
                breakpoints={{
                  0: { slidesPerView: 1 },
                  576: { slidesPerView: 2 },
                  992: { slidesPerView: 3 },
                }}
              >
                {cards.map((c, i) => (
                  <SwiperSlide key={i}>
                    <div className="homeschool-card tilt-card">
                      <img src={c.img} alt={c.title} />
                      <div className="card-caption">
                        <small>{c.title}</small>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
